import {ChangeDetectorRef, Component, ViewChild} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {TerminalEntityModel} from "../terminal-entity.model";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {TerminalData} from "../terminal.data";
import {EditPageComponent} from "../../../framework/entity/edit/edit-page/edit-page.component";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-terminal-edit-page",
    templateUrl: "./terminal-edit-page.component.html",
    providers: [provideEntityModel(TerminalEntityModel)]
})
export class TerminalEditPageComponent extends AbstractEditPage {
    TerminalData = TerminalData;

    @ViewChild(EditPageComponent) editPage: EditPageComponent;

    constructor(public model: TerminalEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    typeSelect(): void {
        if (this.model.data.type !== TerminalData.FUNCTIONAL_TYPE) {
            this.model.data.functionalTerminal = undefined;
        }
    }

    addingAnother(previousEntity: TerminalData): void {
        this.model.data.type = previousEntity.type;
    }
}
